import queryString from 'query-string'
import apiClient from './api-client'

function urlFor(collectionName, id, commentId, extraPrefix) {
  const v2Collections = ['remote-checks']
  const v2 = v2Collections.includes(collectionName) ? 'v2/' : ''
  const prefix = extraPrefix ? `${extraPrefix}/` : ''
  const base = `${v2}${prefix}${collectionName}/${id}/comments`

  return commentId ? `${base}/${commentId}` : base
}

function list(collectionName, id, page, extraPrefix) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: urlFor(collectionName, id, null, extraPrefix),
      query: { page },
    }),
    { withHeaders: true },
  )
}

function listAll(collectionName, id, page, extraPrefix) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `${urlFor(
        collectionName,
        id,
        null,
        extraPrefix,
      )}?type=patient,alert,office_check,report,pre_authorization`,
      query: { page },
    }),
    { withHeaders: true },
  )
}

function create(collectionName, id, comment, extraPrefix) {
  return apiClient.post(urlFor(collectionName, id, null, extraPrefix), {
    comment,
  })
}

function update(collectionName, id, comment, extraPrefix) {
  return apiClient.patch(urlFor(collectionName, id, comment.id, extraPrefix), {
    comment,
  })
}

function destroy(collectionName, id, commentId, extraPrefix) {
  return apiClient.destroy(urlFor(collectionName, id, commentId, extraPrefix))
}

export default {
  create,
  destroy,
  list,
  listAll,
  update,
}
